<template>
    <div class="bg">
        <el-header style="height: 4%; display: flex;justify-content: space-between;">
            <div style="display: flex;gap:10px;">
                <img src="@/assets/favicon.png" alt="">
                <div class="header-text-left">凌丰供应商系统</div>
                <div class="pe-header-text">加工送货单（明细）</div>
            </div>
            <div style="width: 320px;">
                <div class="header-right">欢迎您，{{ userNme }} ({{ roleName }}) </div>
                <div class="header-right" style="color: #fff;">{{ homeDate }}</div>
            </div>
        </el-header>
        <div class="proc_nav">
            <div class="nav_left">
                <el-descriptions title="" :column="4" border>
                    <el-descriptions-item label="单据编号" :contentStyle="{ width: '180px', }" :labelStyle="labelStyle">
                        <div>{{ headObj.formCode }}</div>
                    </el-descriptions-item>
                    <el-descriptions-item label="加工商" contentStyle='width :180px' :labelStyle="labelStyle">
                        <div>{{ headObj.procSupplier?.supplierName }}</div>
                    </el-descriptions-item>
                    <el-descriptions-item label="建单日期" contentStyle='width :150px' :labelStyle="labelStyle">
                        <div>{{ formatDateYear(headObj.createTime) }}</div>
                    </el-descriptions-item>
                    <el-descriptions-item label="完成日期" contentStyle='width :150px' :labelStyle="labelStyle">
                        <div>{{ formatDateYear(headObj.finishTime) }}</div>
                    </el-descriptions-item>
                    <el-descriptions-item label="总金额" contentStyle='width :150px' :labelStyle="labelStyle">
                        <div>{{ headObj.totalPrice }} （元）</div>
                    </el-descriptions-item>
                    <el-descriptions-item label="状态" contentStyle='width :150px' :labelStyle="labelStyle">
                        <div :style="{ color: headObj.status == 0 ? 'orange' : headObj.status == 1 ? 'green' : headObj.status == -1 ? 'red' : '' }">
                            {{
                                headObj.status == 0 ? '申请中' : headObj.status == 1 ? '通过' : headObj.status == -1 ? '驳回' : '' }}
                            <el-popover v-if="headObj.status == -1" placement="top" trigger="hover" width="320" @show="loadRejectReason(headObj.formCode)">
                                <div class="reject-reason-content">{{ rejectReasonText(headObj.formCode) }}</div>
                                <i slot="reference" class="el-icon-warning-outline reject-reason-icon" title="查看驳回原因"></i>
                            </el-popover>
                        </div>
                    </el-descriptions-item>
                    <el-descriptions-item label="审批进度" contentStyle='width :180px' :labelStyle="labelStyle">
                        <div class="audit-progress-cell">
                            <el-progress :percentage="auditPercent(headObj)" :color="auditProgressColor(headObj)" :stroke-width="10" :show-text="false"></el-progress>
                            <span class="audit-progress-text" :style="{ color: auditProgressColor(headObj) }">{{ auditPercent(headObj) }}%</span>
                        </div>
                    </el-descriptions-item>
                    <el-descriptions-item label="合同号" contentStyle='width :200px' :labelStyle="labelStyle">
                        <div>{{ headObj.project?.trackNumber }}</div>
                    </el-descriptions-item>
                    <el-descriptions-item label="项目名称" contentStyle='width :400px' :labelStyle="labelStyle">
                        <div>{{ headObj.projectName }}</div>
                    </el-descriptions-item>
                </el-descriptions>
            </div>
            <div class="nav_right">
                <div style="display: flex;gap:10px;">
                    <el-button size="small" type="primary" @click="search">刷新</el-button>
                    <el-button v-if="headObj.status == 1" size="small" type="warning" @click="expExcel">导出</el-button>
                    <el-dropdown trigger="click" style="margin: 0 10px" v-if="headObj.isAudit === false && roleName == '管理员'">
                        <el-button size="small" type="success">审批
                            <i class="el-icon-arrow-down el-icon--right"></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown" placement="bottom-start">
                            <el-dropdown-item @click.native="approve(1, '')">批准</el-dropdown-item>
                            <el-dropdown-item @click.native="openDisApprove">驳回</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                    <el-button size="small" type="primary" plain @click="printLabelCard">打印物料标识卡</el-button>
                    <el-button v-if="headObj.status == 0 && roleName == '供应商'" size="small" type="warning" @click="urge">催审核</el-button>
                </div>
            </div>
            <div style="position: absolute;right: 40%;top: 5%;">
                <div style="height: 75px;" v-if="headObj.status == 1">
                    <img style="height: 100%;" src="@/assets/approve.png" alt="">
                </div>
                <div style="height: 75px;" v-if="headObj.status == -1">
                    <img style="height: 100%;" src="@/assets/disapprove.png" alt="">
                </div>
                <div style="height: 75px;" v-if="headObj.status == 0">
                    <img style="height: 100%;" src="@/assets/waitting2.png" alt="">
                </div>
            </div>
        </div>
        <div class="table-body">
            <el-table ref="procDetailTable" :data="table_data" border stripe height="100%" :header-row-style="{ height: '0' }" :header-cell-style="{
                    background: '#78b5ec',
                    color: '#000',
                    padding: '0',
                    fontWeight: '400',
                    textAlign: 'center',
                }" :row-style="{ height: '35px' }" :cell-style="{ padding: '2px 0' }" :row-class-name="rowClassName" row-key="id" v-loading="table_loading">
                <!-- <el-table-column type="selection" width="40" :reserve-selection="true"></el-table-column> -->
                <el-table-column label="建单时间" prop="createTime" width="160" align="center" sortable show-overflow-tooltip></el-table-column>
                <el-table-column label="审批时间" prop="auditTime" width="160" align="center" sortable show-overflow-tooltip></el-table-column>
                <el-table-column label="签收时间" prop="finishTime" width="160" align="center" sortable show-overflow-tooltip></el-table-column>
                <el-table-column label="图号" prop="mapCode" width="120" align="center" sortable show-overflow-tooltip></el-table-column>
                <!-- <el-table-column label="状态" width="80" align="center" sortable>
                    <template slot-scope="ss">
                        <div :style="{ color: (statusList.find(item => item.id == ss.row.status))?.color }">
                            {{ (statusList.find(item => item.id == ss.row.status))?.name }}</div>
                    </template>
</el-table-column> -->
                <el-table-column label="组件名称" prop="headMaterial" width="200" align="left" show-overflow-tooltip sortable></el-table-column>
                <el-table-column label="零件号" prop="material.materialCode" width="180" align="left" show-overflow-tooltip sortable></el-table-column>
                <el-table-column label="零件名称" prop="material.materialName" width="200" align="left" show-overflow-tooltip sortable></el-table-column>
                <el-table-column label="备注" prop="remark" width="100" align="left" show-overflow-tooltip />
                <el-table-column label="附件" prop="" width="80" align="center">
                    <template slot-scope="ss">
                        <div v-if="ss.row.commonFileList && ss.row.commonFileList.length > 0">
                            <el-dropdown trigger="click" :ref="`dropdown-${ss.row.id}`" placement="bottom-start" :hide-on-click="false">
                                <el-button type="text" size="media" @click.stop style="padding: 0;">
                                    查看({{ ss.row.commonFileList.length }})
                                </el-button>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item v-for="(file, index) in ss.row.commonFileList" :key="index" class="file-item" @click.native="previewFile(file, ss.row)">
                                        <div style="display: flex; justify-content: space-between; align-items: center; width: 100%;border-bottom: solid 1px #ccc;">
                                            <span style="flex: 1; text-align: left; margin-right: 30px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;"
                                                :title="`上传时间：${file.uploadTime}`">
                                                {{ file.originalName }} ({{ formatFileSize(file.size) }})
                                            </span>
                                            <div style="display: flex; gap: 10px;">
                                                <el-link type="primary" size="mini" v-if="countFileType(file.originalName) == '图片' || countFileType(file.originalName) == 'PDF'"
                                                    title="预览">
                                                    <i class="el-icon-view"></i>预览
                                                </el-link>
                                                <el-link type="success" size="mini" @click.stop="downloadFile(file)" title="下载">
                                                    <i class="el-icon-download"></i>下载
                                                </el-link>
                                                <el-link type="danger" size="mini" @click.stop="delFile(file)" title="删除">
                                                    <i class="el-icon-delete"></i>删除
                                                </el-link>
                                            </div>
                                        </div>
                                    </el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="发货数量" prop="qty" width="105" align="center" sortable></el-table-column>
                <el-table-column label="单价" prop="unitPrice" width="90" align="center" sortable></el-table-column>
                <el-table-column label="金额" prop="totalPrice" width="90" align="center" sortable></el-table-column>
                <el-table-column label="签收" prop="arrivedQty" width="90" align="center" sortable>
                    <template slot-scope="ss">
                        {{ ss.row.arrivedQty ? ss.row.arrivedQty : '' }}
                    </template>
                </el-table-column>
                <el-table-column align="center" label="操作" width="120">
                    <template slot-scope="ss">
                        <div style="display: flex;gap: 10px;justify-content: center;">
                            <el-link type="primary" @click="openUpload(ss.row)">上传附件</el-link>
                            <el-link type="danger" @click="delItem(ss.row)" v-if="[0, 1].includes(headObj.status)">删除</el-link>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="table-footer">
            <el-pagination background layout="sizes, prev, pager, next, total" :total="total" @size-change="handleSizeChange" @current-change="change_data"
                :current-page="search_obj.currentPage" :page-size="search_obj.pageSize" :page-sizes="[10, 30, 50, 100, 200, 300, 400, 500]">
            </el-pagination>
        </div>
        <el-footer class="page_footer">© 2024 LINKFAIRTECH 版权所有</el-footer>

        <uploadFile :uploadShow.sync="uploadShow" :currentRow="currentRow" tableName="proc_sent_form" @uploadClose="uploadClose">
        </uploadFile>
        <viewFileMin :file="currentViewFile" :visible="viewOffice" @updateVisible="updateVisible"></viewFileMin>
        <imageView :img_show.sync="img_show" :fileName="currentFileName" :filePath="currentFilePath" @imageClose="imageClose">
        </imageView>

        <el-dialog title="驳回意见" :visible.sync="disApprove_show" width="30%">
            <el-input type="textarea" rows="4" v-model="disApproveRemark" placeholder="请输入驳回意见" size="small"></el-input>
            <div slot="footer" class="dialog-footer">
                <el-button size="small" @click="disApprove_show = false">取 消</el-button>
                <el-button type="success" plain size="small" @click="disApprove_submit">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { get_procSupplier, formatDateYear, get_project } from "@/utils/func";
import { getOutSourceSendApi, getOutSourceSendItemApi, delProcSendItemApi, auditApi, auditProgressApi, urgeApi } from "@/Api/procApi";
import { exportExcel } from "@/utils/utils";
import * as fileApi from "@/Api/fileApi";
import uploadFile from "@/components/uploadFile.vue";
import viewFileMin from "@/components/viewFileMin.vue";
import imageView from "@/components/imageView.vue";
export default {
    name: "procSend_detail",
    components: {
        uploadFile,
        viewFileMin,
        imageView,
    },
    data() {
        return {
            timer: "",
            homeDate: "",
            headObj: "",
            userNme: sessionStorage.getItem("userName"),
            labelStyle: { width: "80px", textAlign: "center", color: "#4d4d4d", backgroundColor: "#fff" },
            radio1: "全部",
            search_obj: {
                pageSize: 30,
                currentPage: 1,
            },
            total: 30,
            gettable_params: {
                pageSize: 30,
                currentPage: 1,
                keyword: "",
            },
            header: {
                headers: { token: sessionStorage.getItem("token") },
            },
            table_data: [],
            table_loading: false,
            genData: [],
            useDate: "",
            loading2: false,
            project_options: [],
            contract_options: [],
            material_options: [],
            supplier_options: [],
            gen_visiable: false,
            addname_visiable: false,
            status_list: ["未发货", "部分发货", "在途", "部分签收", "签收完成"],
            select_alias: "",
            roleName: sessionStorage.getItem("roleName"),
            flag: false,

            statusList: [
                { id: 1, name: "保存", color: "blue" },
                { id: 2, name: "提交", color: "#ef7b15" },
                { id: 4, name: "审核", color: "#12CAD6" },
                { id: 8, name: "签收", color: "green" },
                { id: -4, name: "不通过", color: "red" },
            ],
            uploadShow: false,
            currentRow: {},

            currentViewFile: {},
            viewOffice: false,

            img_show: false,
            currentFileName: "",
            currentFilePath: "",
            blobUrl: "",
            //驳回原因缓存（formCode -> remark）
            rejectReasonMap: {},
            //正在加载驳回原因的单据（formCode -> true），避免重复请求
            rejectReasonLoading: {},
            disApprove_show: false,
            disApproveRemark: "",
        };
    },
    computed: {},
    methods: {
        formatDateYear,
        //审批进度百分比（0~1 转 0~100）
        auditPercent(row) {
            return Math.round((row.auditProgress || 0) * 100);
        },
        //审批进度条颜色
        auditProgressColor(row) {
            const p = this.auditPercent(row);
            if (p >= 100) return "#67C23A";
            if (p === 0) return "#C0C4CC";
            return "#12b4bd";
        },
        //多人联审审批：result 1=批准 2=驳回（驳回需传 remark）
        approve(result, remark) {
            this.$confirm(`确认${result == 2 ? "驳回" : "批准"}吗？`, "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    let searchObj = {
                        formCode: this.headObj.formCode,
                        pageSize: 999,
                        currentPage: 1,
                    };
                    getOutSourceSendItemApi(searchObj, this)
                        .then((res) => {
                            let submitData = res.records.map((item) => {
                                return {
                                    sentFormId: item.id,
                                    result: result,
                                    remark: remark,
                                };
                            });
                            auditApi(submitData, this)
                                .then(() => {
                                    this.$message.success("审批成功");
                                    let obj = {
                                        formCode: this.headObj.formCode,
                                        pageSize: 1,
                                        currentPage: 1,
                                    };
                                    getOutSourceSendApi(obj, this)
                                        .then((res2) => {
                                            this.headObj = res2.records[0];
                                            this.search_obj.formCode = this.headObj.formCode;
                                            this.search();
                                        })
                                        .catch(() => {});
                                })
                                .catch(() => {
                                    this.$message.error("审批失败");
                                });
                        })
                        .catch(() => {});
                })
                .catch(() => {});
        },
        //打开驳回意见输入弹窗
        openDisApprove() {
            this.disApprove_show = true;
        },
        //确认驳回
        disApprove_submit() {
            if (!this.disApproveRemark) {
                this.$message.error("请输入驳回意见");
                return;
            }
            this.disApprove_show = false;
            this.approve(2, this.disApproveRemark);
        },
        //加载驳回原因：审批进度中取 result 值为 2 的记录，其 remark 即为驳回原因
        loadRejectReason(formCode) {
            if (!formCode || this.rejectReasonMap[formCode] !== undefined || this.rejectReasonLoading[formCode]) return;
            this.rejectReasonLoading[formCode] = true;
            auditProgressApi({ formCode }, this)
                .then((res) => {
                    const list = res || [];
                    let remark = "";
                    //倒序查找，优先取最近一次的驳回记录
                    for (let i = list.length - 1; i >= 0; i--) {
                        if (list[i].result == 2) {
                            remark = list[i].remark || "";
                            break;
                        }
                    }
                    this.$set(this.rejectReasonMap, formCode, remark);
                })
                .catch(() => {})
                .finally(() => {
                    delete this.rejectReasonLoading[formCode];
                });
        },
        //悬浮气泡显示的文案
        rejectReasonText(formCode) {
            if (this.rejectReasonMap[formCode] !== undefined) {
                return this.rejectReasonMap[formCode] || "暂无驳回原因";
            }
            return "驳回原因加载中...";
        },
        //打开上传文件弹窗
        openUpload(row) {
            this.currentRow = structuredClone(row);
            this.uploadShow = true;
        },
        //上传文件关闭
        uploadClose() {
            this.uploadShow = false;
            this.get_data();
        },
        updateVisible(e) {
            this.viewOffice = e;
            this.$nextTick(() => {
                this.$refs[`dropdown-${this.currentRow.id}`].show();
            });
        },
        //图片关闭
        imageClose() {
            this.img_show = false;
            this.$nextTick(() => {
                this.$refs[`dropdown-${this.currentRow.id}`].show();
            });
        },
        //显示时间
        showTime() {
            this.timer = setInterval(() => {
                this.homeDate = this.$getTime();
            }, 1000);
        },
        get_data() {
            getOutSourceSendItemApi(this.search_obj, this)
                .then((res) => {
                    this.table_data = res.records;
                    this.total = res.total;
                })
                .catch(() => {});
        },
        rowClassName({ row }) {
            const boll = this.$refs.procDetailTable.selection.some((item) => item.id == row.id);
            if (boll) return "selected-row";
        },
        //页码发生变化时
        change_data(e) {
            this.search_obj.currentPage = e;
            this.get_data();
        },
        //修改每页大小
        handleSizeChange(e) {
            this.search_obj.pageSize = e;
            this.search_obj.currentPage = 1;
            this.get_data();
        },
        //状态颜色
        status_color(row) {
            if (row.statusName == "未发货") return "info";
            else if (row.statusName == "部分发货") return "warning";
            else if (row.statusName == "在途" || row.statusName == "部分签收") return "";
            else if (row.statusName == "签收完成") return "success";
        },
        goto_sendPage() {
            const { href } = this.$router.resolve({
                path: "/sendPage",
            });
            window.open(href, "_blank");
        },
        clear_selection() {
            this.$confirm("清空所有勾选吗？", "提示", {
                confirmButtonText: "清空",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    this.$refs.procDetailTable.clearSelection();
                })
                .catch(() => {});
        },
        usedate_change() {
            if (this.useDate) {
                this.search_obj.startUseDate = this.useDate[0];
                this.search_obj.endUseDate = this.useDate[1];
            } else {
                this.search_obj.startUseDate = "";
                this.search_obj.endUseDate = "";
            }
        },
        per_gen() {
            if (this.$refs.procDetailTable.selection.length == 0) {
                this.$alert("请先勾选选项", "警告", { type: "error" });
                return;
            }
            // for (let item of this.$refs.procDetailTable.selection) {
            //     if (item.statusName != '未发货' && item.statusName != '部分发货') {
            //         this.$message({ type: 'warning', message: '请勾选未发货或部分发货的选项' })
            //         return
            //     }
            // }
            this.genData = structuredClone(this.$refs.procDetailTable.selection).map((item) => {
                return {
                    ...item,
                    gen_totalprice: 0,
                    gen_num: 0,
                };
            });
            this.gen_visiable = true;
        },
        select_function(row) {
            if (row.statusName != "未发货" && row.statusName != "部分发货") return false;
            return true;
        },
        count_totalprice(row) {
            row.gen_totalprice = (row.unitPrice * row.gen_num).toFixed(2);
        },
        // 预览页剔除项
        item_close(row) {
            let findRes = this.$refs.procDetailTable.selection.find((item) => item.id == row.id);
            if (findRes) {
                this.genData = this.genData.filter((item) => item.id != row.id);
                this.$refs.procDetailTable.toggleRowSelection(findRes);
            }
        },
        fill_gennum() {
            // this.multipleSelection.forEach(item => {
            //     item.gen_num = item.buyNumber - item.outputNumber
            //     item.gen_totalprice = (item.price * item.gen_num).toFixed(2)
            // })
            this.genData = this.genData.map((item) => {
                return {
                    ...item,
                    gen_num: item.qty - item.arrivedQty,
                    gen_totalprice: (item.unitPrice * (item.qty - item.arrivedQty)).toFixed(2),
                };
            });
        },

        // 生成送货单
        gen_send() {
            if (this.genData.length == 0) {
                this.$alert("请先勾选单据项", "警告", { type: "error" });
                return;
            }
            this.genData.forEach((item) => {
                if (item.gen_num == 0) {
                    return;
                }
            });
            this.$confirm("确定生成送货单？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
            })
                .then(() => {})
                .catch(() => {});
        },
        search() {
            this.search_obj.currentPage = 1;
            this.get_data();
        },

        async get_procSupplierOptions(query) {
            get_procSupplier(this, query);
        },
        delItem(row) {
            this.$confirm(
                `送货单编号：${row.formCode}
            </br>零件号：${row.material?.materialCode}
            </br>零件名称：${row.material?.materialName}
            </br>数量：${row.qty}
            </br>单价：${row.unitPrice}
            </br>金额：${row.totalPrice}
            `,
                "确认删除该项数据？",
                {
                    confirmButtonText: "确认",
                    cancelButtonText: "取消",
                    type: "warning",
                    dangerouslyUseHTMLString: true,
                }
            )
                .then(() => {
                    delProcSendItemApi([row.id], this)
                        .then(() => {
                            this.get_data();
                        })
                        .catch(() => {});
                })
                .catch(() => {});
        },
        expExcel() {
            if (this.table_data.length == 0) {
                this.$alert("表格无数据", "异常导出", { type: "warning" });
                return;
            }
            let titleList = ["图号", "组件名称", "零件号", "零件名称", "备注", "发货数量", "单价", "金额(元)"];
            let rows = [];
            this.headObj.sumQuantity = this.table_data.reduce((sum, item) => sum + item.qty, 0);
            this.headObj.sumTotalPrice = this.table_data.reduce((sum, item) => sum + item.totalPrice, 0);
            this.table_data.forEach((item, index) => {
                let tem = [item.mapCode, item.headMaterial, item.material?.materialCode, item.material?.materialName, item.remark, item.qty, item.unitPrice, item.totalPrice];
                rows.push(tem);
            });
            exportExcel(this.headObj, titleList, rows, `加工送货单${this.headObj.formCode}.xlsx`);
        },
        //打印物料标识卡
        printLabelCard() {
            if (this.table_data.length == 0) {
                this.$alert("表格无数据", "提示", { type: "warning" });
                return;
            }
            const { href } = this.$router.resolve({
                path: "/procSendLabel",
                query: {
                    formCode: this.headObj.formCode,
                },
            });
            window.open(href, "_blank");
        },

        countFileType(name) {
            if (name.toLowerCase().match(/\.(jpg|jpeg|png|gif|bmp)$/)) return "图片";
            if (name.toLowerCase().match(/\.(pdf)$/)) return "PDF";
            return name.split(".").pop();
        },
        formatFileSize(bytes) {
            if (bytes === 0) return "0 B";
            const k = 1024;
            const sizes = ["B", "KB", "MB", "GB"];
            const i = Math.floor(Math.log(bytes) / Math.log(k));
            return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
        },
        previewFile(file, row) {
            this.currentRow = structuredClone(row);
            const fileType = this.countFileType(file.originalName);

            if (fileType === "PDF") {
                fileApi
                    .viewFileApi(file.id, this)
                    .then((blob) => {
                        const blobUrl = URL.createObjectURL(new Blob([blob], { type: "application/pdf" }));
                        const newWindow = window.open(blobUrl, "_blank");
                        if (!newWindow || newWindow.closed || typeof newWindow.closed === "undefined") {
                            this.$message.warning("弹出窗口被阻止，请允许浏览器弹出窗口或手动下载后查看");
                            // 备选方案：创建下载链接
                            this.downloadBlob(blob, file.originalName);
                        }
                    })
                    .catch(() => {});
            } else if (fileType === "图片") {
                this.currentFileName = file.originalName;
                this.currentFilePath = file.id;
                this.img_show = true;
            } else if (["doc", "docx", "xls", "xlsx"].includes(file.originalName.split(".").pop().toLowerCase())) {
                this.currentViewFile = file;
                this.viewOffice = true;
            }
        },
        // 下载Blob
        downloadBlob(blob, filename) {
            const url = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = filename;
            document.body.appendChild(a);
            a.click();
            setTimeout(() => {
                document.body.removeChild(a);
                URL.revokeObjectURL(url);
            }, 100);
        },
        downloadFile(file) {
            fileApi
                .viewFileApi(file.id, this)
                .then((blob) => {
                    const url = URL.createObjectURL(blob);
                    const a = document.createElement("a");
                    a.href = url;
                    a.download = file.originalName;
                    document.body.appendChild(a);
                    a.click();
                    setTimeout(() => {
                        document.body.removeChild(a);
                        URL.revokeObjectURL(url);
                    }, 100);
                    this.$message.success(`开始下载: ${file.originalName} (${this.formatFileSize(file.size)})`);
                })
                .catch(() => {
                    this.$message.error("文件下载失败，请重试");
                });
        },
        delFile(file) {
            this.$confirm("确定删除该文件吗？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    fileApi
                        .delFileApi(file.id, this)
                        .then(() => {
                            this.$message.success("删除成功");
                            this.get_data();
                        })
                        .catch(() => {
                            this.$message.error("删除失败");
                        });
                })
                .catch(() => {});
        },
        //催审核
        urge() {
            this.$confirm("确定催审核吗？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            })
                .then(() => {
                    urgeApi({ formCode: this.headObj.formCode }, this)
                        .then(() => {
                            this.$message.success("成功发送消息通知审核人员");
                        })
                        .catch(() => {
                            this.$message.error("发送消息通知审核人员失败");
                        });
                })
                .catch(() => {});
        },
    },
    mounted() {
        this.showTime();
        let obj = {};
        if (this.$route.query.row) {
            let tem = JSON.parse(this.$route.query.row);
            obj = {
                formCode: tem.formCode,
                pageSize: 1,
                currentPage: 1,
            };
            // this.headObj = JSON.parse(this.$route.query.row)
            // this.search_obj.formCode = this.headObj.formCode
            // this.search()
        } else if (this.$route.query.formCode) {
            obj = {
                formCode: this.$route.query.formCode,
                pageSize: 1,
                currentPage: 1,
            };
        }
        getOutSourceSendApi(obj, this)
            .then((res) => {
                this.headObj = res.records[0];
                this.search_obj.formCode = this.headObj.formCode;
                this.search();
            })
            .catch(() => {});
    },
    created() {},
    beforeDestroy() {
        if (this.timer) {
            clearInterval(this.timer);
            this.timer = "";
        }
    },
};
</script>
<style scoped>
.bg {
    height: 100%;
    display: flex;
    flex-direction: column;
}
.title {
    font-size: 20px;
    font-family: "黑体";
    font-weight: 700;
    height: 4%;
    display: flex;
    padding-left: 10px;
    align-items: center;
}

.proc_nav {
    /* height: 9%; */
    display: flex;
    align-items: center;
    padding: 0 15px;
    background: #fff;
    border-bottom: 1px solid #f0f0f0;
}

.nav_left {
    /* width: 75%; */
}

.nav_right {
    display: flex;
    flex-direction: column;
    gap: 5px;
    align-items: center;
    justify-content: center;
    width: 22%;
    flex-wrap: wrap;
    margin-left: 60px;
}

.header-text-left {
    height: 38px;
    line-height: 38px;
    font-size: 22px;
    font-weight: 700;
    color: #fff;
}

.pe-header-text {
    margin-left: 12px;
    font-size: 16px;
    font-weight: 600;
    line-height: 45px;
    color: rgba(255, 255, 255, 0.9);
}

.header-right {
    font-size: 13px;
    height: 19px;
    line-height: 25px;
    text-align: right;
    padding-right: 15px;
    color: rgba(255, 255, 255, 0.85);
}

.header-right:first-child {
    font-weight: 500;
}

.table-body {
    /* height: 80%; */
    flex: 1;
    padding: 15px;
}

.table-footer {
    height: 5%;
    display: flex;
    padding-left: 15px;
    align-items: center;
    justify-content: center;
    background-color: #fff;
    border-top: 1px solid #f0f0f0;
}
.page_footer {
    height: 2% !important;
    font-size: 13px;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
}
.dialog-height::v-deep .el-table__body-wrapper {
    max-height: 65vh !important;
    overflow: scroll;
    padding-top: 0px;
}

.dialog-height::v-deep .el-dialog__body {
    padding: 20px !important;
}

/deep/.el-table .sort-caret.ascending {
    border-bottom-color: #fff;
}

/deep/.el-table .ascending .sort-caret.ascending {
    border-bottom-color: #d5d9dd;
}

/deep/.el-table .sort-caret.descending {
    border-top-color: #fff;
}

/deep/.el-table .descending .sort-caret.descending {
    border-top-color: #d5d9dd;
}

.nav_left >>> .el-descriptions-item__cell {
    padding: 8px 5px !important;
}

.reject-reason-icon {
    margin-left: 2px;
    color: #f56c6c;
    cursor: help;
    font-size: 14px;
    vertical-align: -1px;
}

.reject-reason-content {
    max-height: 200px;
    overflow-y: auto;
    font-size: 13px;
    line-height: 1.5;
    white-space: pre-wrap;
    word-break: break-all;
}

.audit-progress-cell {
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 130px;
}

.audit-progress-cell .el-progress {
    flex: 1;
    min-width: 0;
}

.audit-progress-text {
    font-size: 12px;
    font-weight: 600;
    white-space: nowrap;
}

.gen_data {
    height: 780px;
}

/deep/ .el-dialog__body {
    padding: 20px !important;
}
</style>
<style>
.bg >>> .el-table .cell {
    padding: 8px 3px;
}
.el-header {
    background-color: #12b4bd;
}

.el-main {
    background-color: #ccc;
}

.el-footer {
    background-color: #12b4bd;
}

.el-table__body tr:hover > td {
    background-color: #c0ddaf !important;
}

/* .table-body .selected-row {
    background-color: #c0ddaf !important;
} */

/* .nav .el-button {
    border-color: #12b4bd;
    color: #12b4bd;
} */

.selected-row > td {
    background-color: #c0ddaf !important;
}

.table-body .el-table .el-checkbox {
    transform: scale(1.5);
}

.el-table__body-wrapper::-webkit-scrollbar {
    width: 10px;
    height: 10px;
}

.el-table__body-wrapper::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.185);
    border-radius: 5px;
}

.bg .el-dialog {
    margin-top: 0;
    margin-bottom: 0;
}

.gen_data .el-table__body-wrapper::-webkit-scrollbar {
    width: 5px !important;
    height: 0 !important;
}

.el-input--mini {
    font-size: 14px !important;
}
</style>